import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type LanguageCatalogueStatusFilter = 'all' | 'draft' | 'active';

export type PlatformLanguagesPageState = {
  addLanguageModalOpen: boolean;
  pendingPublishConfirm: { localeCode: string } | null;
  pendingRemoveConfirm: { localeCode: string } | null;
  submitInProgress: boolean;
  lastErrorKey: string | null;
  filters: { status: LanguageCatalogueStatusFilter };
};

const initialState: PlatformLanguagesPageState = {
  addLanguageModalOpen: false,
  pendingPublishConfirm: null,
  pendingRemoveConfirm: null,
  submitInProgress: false,
  lastErrorKey: null,
  filters: { status: 'all' },
};

export const platformLanguagesPageSlice = createSlice({
  name: 'platformLanguagesPage',
  initialState,
  reducers: {
    openAddLanguageModal(state) {
      state.addLanguageModalOpen = true;
      state.submitInProgress = false;
      state.lastErrorKey = null;
    },
    closeAddLanguageModal(state) {
      state.addLanguageModalOpen = false;
      state.submitInProgress = false;
      state.lastErrorKey = null;
    },
    openPublishConfirm(state, action: PayloadAction<{ localeCode: string }>) {
      state.pendingPublishConfirm = action.payload;
      state.submitInProgress = false;
      state.lastErrorKey = null;
    },
    closePublishConfirm(state) {
      state.pendingPublishConfirm = null;
      state.submitInProgress = false;
      state.lastErrorKey = null;
    },
    openRemoveConfirm(state, action: PayloadAction<{ localeCode: string }>) {
      state.pendingRemoveConfirm = action.payload;
      state.submitInProgress = false;
      state.lastErrorKey = null;
    },
    closeRemoveConfirm(state) {
      state.pendingRemoveConfirm = null;
      state.submitInProgress = false;
      state.lastErrorKey = null;
    },
    setSubmitInProgress(state, action: PayloadAction<boolean>) {
      state.submitInProgress = action.payload;
    },
    setLastErrorKey(state, action: PayloadAction<string | null>) {
      state.lastErrorKey = action.payload;
    },
    setStatusFilter(state, action: PayloadAction<LanguageCatalogueStatusFilter>) {
      state.filters.status = action.payload;
    },
  },
});

export const {
  openAddLanguageModal,
  closeAddLanguageModal,
  openPublishConfirm,
  closePublishConfirm,
  openRemoveConfirm,
  closeRemoveConfirm,
  setSubmitInProgress,
  setLastErrorKey,
  setStatusFilter,
} = platformLanguagesPageSlice.actions;

type AppRootState = {
  platformLanguagesPage: PlatformLanguagesPageState;
};

export const selectPlatformLanguagesPage = (state: AppRootState) =>
  state.platformLanguagesPage;
